<template>
	<section class="new-home-hero">
		<iframe
			class="new-home-hero__video"
			src="https://www.youtube.com/embed/03mJ7u8vyQc?autoplay=1&amp;mute=1&amp;loop=1&amp;playlist=03mJ7u8vyQc&amp;controls=0&amp;modestbranding=1&amp;rel=0&amp;playsinline=1&amp;disablekb=1&amp;fs=0&amp;iv_load_policy=3&amp;cc_load_policy=0"
			:title="hero.videoTitle"
			frameborder="0"
			allow="autoplay; fullscreen"
			allowfullscreen
		></iframe>
		<div class="new-home-hero__shade"></div>

		<div class="new-home-hero__content">
			<h1>
				<strong>{{headline.strongStart}}</strong>
				{{headline.middle}}
				<br>
				{{headline.endStart}}
				<strong>{{headline.strongEnd}}</strong>
			</h1>
		</div>
	</section>
</template>

<script>
import { translate } from '../../assets/translations';

export default {
	computed: {
		hero() {
			return translate(this.$store.state.language).home.hero;
		},
		headline() {
			return this.hero.headline;
		},
	},
};
</script>

<style scoped lang="scss">
.new-home-hero {
	position: relative;
	height: 100vh;
	height: 100svh;
	max-height: 100vh;
	max-height: 100svh;
	overflow: hidden;
	background: #092c3f;
	color: #ffffff;
}

.new-home-hero__video {
	position: absolute;
	top: 50%;
	left: 50%;
	width: 116vw;
	height: 65.25vw;
	min-width: 206.22vh;
	max-height: 100vh;
	max-height: 100svh;
	border: 0;
	pointer-events: none;
	transform: translate(-50%, -50%) scale(1.2);
}

.new-home-hero__shade {
	position: absolute;
	inset: 0;
	background:
		linear-gradient(90deg, rgba(0, 0, 0, .42) 0%, rgba(0, 0, 0, .18) 48%, rgba(0, 0, 0, .05) 100%),
		linear-gradient(0deg, rgba(0, 0, 0, .14), rgba(0, 0, 0, .08));
}

.new-home-hero__content {
	position: relative;
	z-index: 1;
	display: flex;
	align-items: center;
	height: 100vh;
	height: 100svh;
	max-height: 100vh;
	max-height: 100svh;
	padding: 50px 5% 86px;
}

.new-home-hero h1 {
	max-width: 790px;
	margin: 0;
	color: #ffffff;
	font-size: 30px;
	font-weight: 300;
	line-height: 1.12;
	letter-spacing: 0;
}

.new-home-hero strong {
	font-weight: 800;
}

@media (max-width: 820px) {
	.new-home-hero__video {
		width: 177.78vh;
		width: 177.78svh;
		height: 100vh;
		height: 100svh;
		min-width: 100%;
		min-height: 100%;
		max-height: none;
		transform: translate(-50%, -50%);
	}

	.new-home-hero__content {
		padding: 120px 34px 70px;
	}

	.new-home-hero h1 {
		font-size: 34px;
	}
}

@media (max-width: 520px) {
	.new-home-hero__content {
		padding: 114px 24px 72px;
	}

	.new-home-hero h1 {
		font-size: 29px;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/home/HomeHero.vue